import { createContext, useContext } from "react";

export type PastDatesState = {
  pastFetchesCount: number;
  canScrollInPast: boolean;
};

export type PastDatesApi = {
  incrementPastFetchesCount: () => void;
  setCanScrollInPast: (canScrollInPast: boolean) => void;
};

const PAST_DATES_INITIAL_STATE: PastDatesState = {
  pastFetchesCount: 0,
  canScrollInPast: false
};

const PAST_DATES_INITIAL_API: PastDatesApi = {
  incrementPastFetchesCount: () => {},
  setCanScrollInPast: () => {}
};

export const PastDatesStateContext = createContext<PastDatesState>(PAST_DATES_INITIAL_STATE);
export const PastDatesApiContext = createContext<PastDatesApi>(PAST_DATES_INITIAL_API);

export const usePastDatesStateContext = () => useContext(PastDatesStateContext);
export const usePastDatesApiContext = () => useContext(PastDatesApiContext);
